/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled, { keyframes } from "styled-components";

import { SpinnerBallSVG } from "./SpinnerBallSVG";

export const CSSBall = () => (
  <SpinnerBall>
    <SpinnerBallSVG />
  </SpinnerBall>
);

const loadingRotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  16.7% {
    transform: rotate(60deg);
  }
  33.3% {
    transform: rotate(120deg);
  }
  50% {
    transform: rotate(180deg);
  }
  66.76% {
    transform: rotate(240deg);
  }
  83.46% {
    transform: rotate(300deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerBall = styled.div`
  animation-name: ${loadingRotate};
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #c4c4c4;
`;
